
	import { defineComponent } from 'vue'

	import ApplyStep from '@/components/ApplyStep.vue'

	import { useApplyToProgram, useRecordVisits } from '../composables/useBackend'

	export default defineComponent({
		components: {
			ApplyStep,
		},

		setup() {
			useRecordVisits()

			const {
				email,
				orderNumber,
				isStatus,
				apply,
			} = useApplyToProgram()

			return {
				email,
				orderNumber,
				isInvalid: isStatus('Invalid'),
				isLoading: isStatus('Loading'),
				isSuccessful: isStatus('Completed'),
				apply,
			}
		},
	})
